import { render } from "./Logo.vue?vue&type=template&id=63a48243&scoped=true"
const script = {}

import "./Logo.vue?vue&type=style&index=0&id=63a48243&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63a48243"]])

export default __exports__